/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import Head from 'next/head';
import {useState} from 'react';
import styled from 'styled-components';
import {Columns, UpdatedDate, Wrapper} from '@/components/terms/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    strong: "strong",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(Wrapper, {
    children: [_jsx(_components.h1, {
      children: "Calm Unsolicited Submissions Policy"
    }), _jsxs(_components.p, {
      children: ["We at Calm.com, Inc. (\"", _jsx(_components.strong, {
        children: "Calm"
      }), "\") may sometimes receive submissions proposing ideas for new Calm products and services. We appreciate this interest in Calm and thank everyone who has taken the time and effort to get in touch with us."]
    }), _jsxs(_components.p, {
      children: ["As a matter of policy, Calm does not accept or consider unsolicited creative ideas, materials, or pitches of any kind, including concepts for new Calm content (\"", _jsx(_components.strong, {
        children: "Unsolicited Submissions"
      }), "\")."]
    }), _jsxs(_components.p, {
      children: ["The purpose of this policy is to avoid potential misunderstandings or disagreements in circumstances where Calm materials or projects might seem similar to Unsolicited Submissions made to Calm. ", _jsx(_components.strong, {
        children: "Please do not send Unsolicited Submissions in any form to Calm or its employees."
      })]
    }), _jsx(_components.p, {
      children: "If, despite our policy, you still submit your ideas to Calm or a Calm employee, you agree that the following terms will apply to your Unsolicited Submissions, even if you say otherwise in connection with your submission:"
    }), _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "The Unsolicited Submissions are not confidential or proprietary information."
      }), "\n", _jsx(_components.li, {
        children: "Calm may use and share the Unsolicited Submissions for any purpose in any manner, without compensation or credit to you or anyone else."
      }), "\n", _jsx(_components.li, {
        children: "Calm will not have any obligations concerning the Unsolicited Submissions, including no obligation to review the Unsolicited Submissions, return any materials, or acknowledge receipt of the Unsolicited Submissions."
      }), "\n", _jsx(_components.li, {
        children: "You hereby waive any right to make any claim against Calm in connection with the Unsolicited Submissions."
      }), "\n"]
    }), _jsx(_components.p, {
      children: "If you do not agree to these terms, please do not send Calm or its employees any Unsolicited Submissions. We encourage you to work with an established creative agent who will know how to properly submit ideas for consideration."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
